module.exports = __webpack_public_path__ + "static/7-48850c254592088f13340464b0009903.png";